<script setup lang="ts">
import { CfgPreloader } from '@cfgtech/ui';
import type { Step } from '~/components/AppNavbarStepper.vue';

const { t } = useI18n();

defineProps<{
  isLoading?: boolean;
  isFinished?: boolean
}>();

const dataLayer = useDataLayer();

const steps: Step[] = [
  {
    key: 'settings',
    name: t('common.navigations.settings'),
    route: '/settings',
    closeUrl: '/settings',
    back: true,
  },
  {
    key: 'sync',
    name: '',
    route: '/orders/sync/settings',
    closeUrl: '/settings',
    back: true,
  },
  {
    key: 'success',
    name: '',
    route: '/orders/sync/settings/success',
    closeUrl: '/portfolio',
    back: false,
  }
];

function handleCloseUrl(stepKey: string) {
  if (stepKey === 'success') {
    dataLayer.closeConfirmationScreen(LocationsEnum.SYNC_TURNED_ON_SUCCESS);
  }
}
</script>

<template>
  <div>
    <AppNavbarStepper
      :is-finished="isFinished"
      :steps="steps"
      @close:url="handleCloseUrl"
    />

    <template v-if="!isLoading">
      <main>
        <div class="container p-5">
          <slot />
        </div>
      </main>
    </template>

    <template v-else>
      <div class="flex h-screen flex-col items-center justify-center gap-y-10">
        <CfgPreloader class="text-brand" />

        <slot name="loadingText" />
      </div>
    </template>
  </div>
</template>
